import React, { Component } from 'react';
import PAService from '../services/PASevice';

import UserPointTransactionService from '../services/UserPointTransactionService';
import MessageComponent from '../template/Message';
import productPic from './../assets/images/product-pic.png';
import loadingPic from './../assets/images/loading.gif';
import FakeProductimg from './../assets/images/wrong-code.png';
import SuccessProductimg from './../assets/images/sucess-code.png';
import AlreadyscanProductimg from './../assets/images/already-scan-sign.png';
import logoimg from './../assets/images/logo.png';
import ApiService from '../services/apiService';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';


export default class ProductAuthentication extends Component {
    constructor(props) {
        super(props);
        this.PAService = new PAService();
        this.ApiService = new ApiService();
        this.UserPointTransactionService = new UserPointTransactionService();
        this.state = {
            visible: false,
            formIsValid: false,
            formRedeemIsValid: false,
            Isloyalty: false,
            verifyProduct: {},
            verificationMode: 'Web',
            qrData: window.location.href,
            verificationType: 2,
            UID: '',
            RedeemNumber: '',
            isLoading: true,
            Name: '',
            UsrId: '',
            Points: '',
            Totalpoints: '',
            ProductName: '',
            SchemeName: '',
            PaytmPoint: '',
            Location: '',
            email: '',
            MobNo: '',
            UserName: '',
            UsrFeedback: '',
            feedbackId: 0,
            formError: {
                Name: null,
                email: null,
                MobNo: null,
                UsrFeedback: null
            },
            redeemError: {
                MobNo: null,
                UserName: null
            },

            ProductImage: null,
            GenuineAudio: null,
            LoyaltyPoints: null,
            ProductConfiguration: {},
            CreatedDt: ''
        }

        this.submitForm = this.submitForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.redeemLoyalty = this.redeemLoyalty.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.hideFunc = this.hideFunc.bind(this);
        this.redeemhandleChange = this.redeemhandleChange.bind(this);

    }

    // basic page operation
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);

        //const parmUid = urlParams.get('uid');

        navigator.geolocation.getCurrentPosition(position => {
            console.log(position)

            this.ApiService.reverseGeoCode(position.coords.latitude, position.coords.longitude)
                .then(res => {
                    let data = res.data;
                    console.log(data);

                    const productAuthRequests = {
                        verificationMode: this.state.verificationMode,
                        qrData: this.state.qrData,
                        verificationType: this.state.verificationType,
                        UID: window.location.href,
                        UsrCity: data.address.city,
                        UsrState: data.address.state,
                        UsrCntry: data.address.country,
                        UsrAdrs: data.display_name,
                        UsrZip: data.address.postcode
                    };

                    setTimeout(() => {
                        this.GetVerifyProduct(productAuthRequests);
                    }, 1000);


                }).catch(error => {

                });


        }, error => {
            console.error(error);

            const productAuthRequests = {
                verificationMode: this.state.verificationMode,
                qrData: this.state.qrData,
                verificationType: this.state.verificationType,
                UID: window.location.href,
            };

            setTimeout(() => {
                this.GetVerifyProduct(productAuthRequests);
            }, 1000);



        }, {
            // timeout: 1000,
            // maximumAge: 10000,
            // enableHighAccuracy: true
        })






    }

    // get verify product list data
    GetVerifyProduct(productAuthReq) {
        debugger
        this.setState({
            Isloyalty: false
        });
        this.PAService.VerifyProduct(productAuthReq).then(data => {
            const resdata = data.data.ResponseData[0];
            console.log(resdata);
            //if ResponseData is not null
            if (resdata !== null) {
                this.setState({
                    isLoading: false,
                    verifyProduct: resdata,
                    feedbackId: resdata.FeedbackId,
                    Isloyalty: resdata.Isloyalty,
                    ProductImage: resdata.ProductImg,
                    GenuineAudio: resdata.GenuineAudio,
                    LoyaltyPoints: resdata.LoyaltyPoints,
                    CreatedDt: resdata.CreatedDt
                    // ProductConfiguration: JSON.parse(resdata.ProdConfiguration)
                });
                //if GenuineAudio is not null
                if (this.state.GenuineAudio != null && this.state.verifyProduct.ResponseCode != undefined) {
                    document.getElementById("pm3paly").play();
                }
            } else {
                this.setState({
                    verifyProduct: new {}
                });
            }
        });
    }

    // submit feedback
    submitForm(event) {
        event.preventDefault();
        let isfrmvalid = true;
        let checkerror = this.state.formError;
        debugger

        Object.entries(checkerror).map(([key, value]) => {
            const val = this.state[key]
            let valid = this.validateForm(val, key);
            //form is not valid
            if (!valid) {
                this.setState({ checkerror: isfrmvalid });
                isfrmvalid = false;
            }
        });


        if (isfrmvalid) {

            const feedbackData = {
                Name: this.state.Name,
                email: this.state.email,
                MobNo: this.state.MobNo,
                UsrFeedback: this.state.UsrFeedback,
                feedbackId: this.state.feedbackId,
                CreatedDt: this.state.CreatedDt
            }

            this.PAService.UpdateFeedback(feedbackData).then(data => {
                const resdata = data.data;
                //if ResponseCode is 200 success else error or warning message
                if (resdata.ResponseCode === '200') {
                    debugger
                    this.refs.child.showSuccess(resdata.ResponseMessage);
                    // this.setState({
                    //     Name: "",
                    //     email: "",
                    //     MobNo: "",
                    //     UsrFeedback: "",
                    // });
                    this.formReset();
this.hideFunc();
                } else {
                    this.refs.child.showError(resdata.ResponseMessage);
                }
            }).catch(error => {
                const err = JSON.parse(error.request.response).errors;

                let errors = this.state.formError;
                let erlist = {};
                Object.entries(err).map(([key, value]) => {
                    erlist[key] = errors[key.toLowerCase()] = value[0];
                });
                this.setState({ formError: erlist });
            });
        }

    }

    hideFunc() {
        this.setState({
            visible: false, buttonLabel: 'Submit',
            formHeading: 'Feedback'
        })
        this.formReset();
    }
    openDialog() {
        this.setState({ visible: true });
        this.formReset();
    }

    // redeemloyalty
    redeemLoyalty(event) {
        event.preventDefault();
        const userPoint = {
            UsrId: this.state.UsrId,
            Points: this.state.Points,
            Totalpoints: this.state.Totalpoints,
            ProductName: this.state.ProductName,
            SchemeName: this.state.SchemeName,
            PaytmPoint: this.state.PaytmPoint,
            Location: this.state.Location,
            MobNo: this.state.MobNo,
            UserName: this.state.UserName

        }

        this.UserPointTransactionService.CreateUserPointTransaction(userPoint).then(data => {
            const resdata = data.data;
            //if ResponseCode is 200 success else error or warning message
            if (resdata.ResponseCode === '200') {
                this.refs.child.showSuccess(resdata.ResponseMessage);
            } else {
                this.refs.child.showError(resdata.ResponseMessage);
            }
        }).catch(error => {
            const err = JSON.parse(error.request.response).errors;

            let errors = this.state.formError;
            let erlist = {};
            Object.entries(err).map(([key, value]) => {
                erlist[key] = errors[key.toLowerCase()] = value[0];
            });
            this.setState({ formError: erlist });
        });;
    }

    // redeemhandle
    redeemhandleChange(event) {
        const { name, value } = event.target;
        let errors = this.state.redeemError;
        this.formRedeemIsValid = true;

        //to validate each form field with required conditions
        switch (name) {
            case 'MobNo':
                if (value.length < 1) {
                    this.formRedeemIsValid = false;
                    errors.MobNo = "Please enter your redeem mobile no.";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^[0-9]{10}$/)) {
                        this.formRedeemIsValid = false;
                        errors.MobNo = "Please enter valid redeem mobile no.";
                    } else errors.MobNo = null
                } else errors.MobNo = null
                break;
            case 'UserName':
                if (value.length < 1) {
                    this.formRedeemIsValid = false;
                    errors.UserName = "Please enter your UserName";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^[A-Za-z]+$/)) {
                        this.formRedeemIsValid = false;
                        errors.UserName = "alpha only";
                    } else errors.UserName = null
                } else errors.UserName = null
                break;
            default:
                break;
        }

        this.setState({ [name]: value });
    }

    // reset form text value
    formReset() {
        this.setState({

            Name: '',
            email: '',
            MobNo: '',
            UsrFeedback: '',
            formError: {

                Name: null,
                email: null,
                MobNo: null,
                UsrFeedback: null
            }
        });
        let errors = this.state.formError;
        Object.entries(errors).map(([key, value]) => {
            errors[key] = '';
        });
    }

    // call when input
    handleChange(event) {

        const { name, value } = event.target;
        let errors = this.state.formError;

        const isValid = this.validateForm(value, name);
        this.setState({ errors, [name]: value });
    }

    // validate form
    //resolved KREP-17,KREP-21
    validateForm(value, name) {
        let errors = this.state.formError;
        let IsValid = true;

        //to validate each form field with required conditions
        switch (name) {
            case 'Name':
                if (value.length < 1) {
                    IsValid = false;
                    errors.Name = "Please enter your name.";
                } else if (value.length >= 1) {
                    if (!value.match(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/)) {
                        this.IsValid = false;
                        errors.Name = "Please enter only alphabet.";
                    } else errors.Name = null
                } else errors.Name = null
                break;
            case 'email':
                //     if (value.length < 1) {
                //         IsValid = false;
                //        errors.email = "Please enter your email.";
                //    }  
                if (value.length >= 1) {
                    if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
                        IsValid = false;
                        errors.email = "Please enter valid email-id.";
                    } else errors.email = null
                } else errors.email = null
                break;
            case 'MobNo':
                if (value.length < 1) {
                    IsValid = false;
                    errors.MobNo = "Please enter your mobile no.";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^[6-9]\d{9}$/)) {
                        IsValid = false;
                        errors.MobNo = "Please enter valid mobile no.";
                    } else errors.MobNo = null
                } else errors.MobNo = null
                break;
            case 'UsrFeedback':
                if (value.length < 1) {
                    IsValid = false;
                    errors.UsrFeedback = "Please enter your feedback.";
                } else errors.UsrFeedback = null
                break;
            default: break;
        }

        return IsValid;
    }

    // return HTML
    //resolved KREP-115
    render() {
        let data = '';
        const res = {};
        res["Product Image"] = this.state.verifyProduct.ProductImg;
        res["Product Name"] = this.state.verifyProduct.ProductName;
        res["Product Code"] = this.state.verifyProduct.ProductCd;
        res["Manufacture Name"] = this.state.verifyProduct.ManufactureName;
        res["UID"] = this.state.verifyProduct.SeqNo;
        res["Product Description"] = this.state.verifyProduct.ProductDscrptn;
        res["UOM"] = this.state.verifyProduct.ProductUOM;
        res["Marketed By"] = this.state.verifyProduct.MarketedBy;
        res["Customer Care Details"] = this.state.verifyProduct.CustomerCareDetails;
        res["Expiry Date"] = this.state.verifyProduct.ExpireDate;
        res["Registration No"] = this.state.verifyProduct.RegistrationNo;
        res["D.O.M."] = this.state.verifyProduct.DOM;
        res["Batch No."] = this.state.verifyProduct.BatchNo;
        res["Cautionary Symbol"] = this.state.verifyProduct.CautionarySymbol;
        res["Antidote Statement"] = this.state.verifyProduct.AntidoteStatement;
        //if res not null
        // if (this.state.verifyProduct.ResponseCode == '1' && res != null) {
        //     data = Object.entries(res).map(([key, value], index) => {
        //         return (
        //             <div key={index}>
        //                 <div className="row"><div className="col-md-3"><strong>{key}</strong></div>
        //                     <div className="col-md-9 mb-3"> {value}</div></div>
        //             </div>
        //         );
        //     });
        // }
        // else {
        //     if (this.state.verifyProduct.ResponseCode != undefined && this.state.verifyProduct.ResponseCode != '1') {
        //         data = (
        //             <div className="row">
        //                 <div className="col-md-12 err-mess text-left">It seems you might have bought a fake product.</div>
        //             </div>
        //         );

        //     }
        // }

        return (
            <div className="pa-bg">
                <MessageComponent ref="child" />
                <div className="container">
                    <div>
                        <audio src={this.state.GenuineAudio} id="pm3paly" autoPlay hidden />
                    </div>
                    
                    <h1 className="text-center text-shadow">CERTIFICATE OF AUTHENTICITY </h1>
  <br></br>
                            <img src={this.state.verifyProduct.CompanyLogo} style={{marginLeft: "41%", marginBottom: "20px" }} />
                             <br></br>
                           

                    <div className="product-image"><img src="" alt="" />
                    {/* {this.state.verifyProduct.ProductImg ? <div className="col-md-4 font-weight-bold">Product Image</div> : null} */}
                                            {this.state.verifyProduct.ProductImg ? <div className="col-md-12 mb-1 text-center">
                                                <img src={this.state.verifyProduct.ProductImg} style={{ maxHeight: '250px', border: "3px solid deepskyblue"}} />
                                            </div> : null}</div>
                    {(this.state.verifyProduct.ResponseCode) == "1" ?
                        this.state.isLoading ? <div className="block text-center pt-3"><img src={loadingPic} width="120" /></div> :
                                             
                        <div className="block1">
                             
                             <img src={SuccessProductimg} style={{marginLeft: "42%"}} />
                             <h3 className="text-center"> {this.state.verifyProduct.ResponseMessage}</h3>
                             
                            </div>:""
                    }
                    { (this.state.verifyProduct.ResponseCode) == "2" ?
                        this.state.isLoading ? <div className="block text-center pt-3"><img src={loadingPic} width="120" /></div> :
                                             
                        <div className="block1">
                            <br></br>
                             <img src={AlreadyscanProductimg} style={{marginLeft: "42%" }} />
                             <br></br>
                             <h3 className="text-center"> {this.state.verifyProduct.ResponseMessage}</h3>
                            </div>:""
                    }
                    
                    {(this.state.verifyProduct.ResponseCode) == "1" || (this.state.verifyProduct.ResponseCode) == "2" ?
                        this.state.isLoading ? <div className="block text-center pt-3"><img src={loadingPic} width="120" /></div> :

                        
                            <div className="block">
                                <h2 className="text-center mt-4 mb-5">Product Verification Detail</h2>
                                <div className="row">
                                    {
                                        (this.state.ProductConfiguration != null &&
                                            this.state.ProductConfiguration.IsProductImage) == true
                                            ? <div className="col-md-4 pb-3">
                                                <img src={this.state.ProductImage} width="80%" />
                                            </div>
                                            : ""
                                    }
                                    <div className="col-md-12">
                                        <div className="row">

                                        <div className="col-md-12 border-bottom">    
                                            <div className="col-md-4 font-weight-bold">Unique Identifier</div>
                                           <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.SeqNo}
                                                {/* {this.state.verifyProduct.ProductValue} 
                                         {this.state.verifyProduct.ProductUOM} */}
                                            </div></div>

                                            <div className="col-md-12 border-bottom">    
                                            <div className="col-md-4 font-weight-bold">Product Name</div>
                                           <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.ProductName}
                                                {/* {this.state.verifyProduct.ProductValue} 
                                         {this.state.verifyProduct.ProductUOM} */}
                                            </div></div>
{/* 
                                            {this.state.verifyProduct.ProductDscrptn ? <div className="col-md-4 font-weight-bold">Discription</div> : null}
                                            {this.state.verifyProduct.ProductDscrptn ? <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.ProductDscrptn}
                                            </div> : null} */}
                                            {this.state.verifyProduct.TechnicalName ? <div className="col-md-4 font-weight-bold">Technical Name</div> : null}
                                            {this.state.verifyProduct.TechnicalName ? <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.TechnicalName}
                                            </div> : null}

                                            <div className="col-md-12 border-bottom">
                                            <div className="col-md-4 font-weight-bold">Product Code</div>
                                            <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.ProductCd}
                                            </div></div>

                                            <div className="col-md-12 border-bottom">
                                            <div className="col-md-4 font-weight-bold">Batch No</div>
                                            <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.BatchNo}
                                            </div></div>

                                            {this.state.verifyProduct.SapProductCd ? <div className="col-md-4 font-weight-bold">SAP Code</div> : null}
                                            {this.state.verifyProduct.SapProductCd ? <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.SapProductCd}
                                            </div> : null}

                                            {this.state.verifyProduct.ManufactureName ? <div className="col-md-4 font-weight-bold">Manufacturer Name</div> : null}
                                            {this.state.verifyProduct.ManufactureName ? <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.ManufactureName}
                                            </div> : null}

                                            <div className="col-md-12 border-bottom">  
                                            {this.state.verifyProduct.GTIN ? <div className="col-md-4 font-weight-bold">GTIN</div> : null}
                                            {this.state.verifyProduct.GTIN ?<div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.GTIN}
                                            </div>:null}
                                            
                                            </div>


                                            {this.state.verifyProduct.MarketedBy ? <div className="col-md-4 font-weight-bold">Marketed By</div> : null}
                                            {this.state.verifyProduct.MarketedBy ? <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.MarketedBy}
                                            </div> : null
                                            }



                                            {/* {
                                   this.state.verifyProduct.CustomerCareDetails? <div className="col-md-4 font-weight-bold">Customer Care Details</div>:null
                                   }{
                                   this.state.verifyProduct.CustomerCareDetails?
                                    <div className="col-md-8 mb-3">
                                        {this.state.verifyProduct.CustomerCareDetails}
                                    </div>:null
                                   } */}
                                            {this.state.verifyProduct.ExpireDate ? <div className="col-md-4 font-weight-bold">Expiry Date</div> : null}
                                            {this.state.verifyProduct.ExpireDate ? <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.ExpireDate}
                                            </div> : null}

                                            {this.state.verifyProduct.RegistrationNo ? <div className="col-md-4 font-weight-bold">Registration No</div> : null}
                                            {this.state.verifyProduct.RegistrationNo ? <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.RegistrationNo}
                                            </div> : null}

                                            <div className="col-md-12 border-bottom">
                                            <div className="col-md-4 font-weight-bold">Date of Manufacture</div>
                                            <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.DOM}
                                            </div></div>

                                            <div className="col-md-12 border-bottom">
                                            <div className="col-md-4 font-weight-bold">Date of Expiry</div>
                                            <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.ExpDate}
                                            </div></div>

                                            {this.state.verifyProduct.CautionarySymbol ? <div className="col-md-4 font-weight-bold">Cautionary Symbol</div> : null}
                                            {this.state.verifyProduct.CautionarySymbol ? <div className="col-md-8 mb-3">
                                                <img src={this.state.verifyProduct.CautionarySymbol} style={{ maxWidth: '250px' }} />
                                            </div> : null}

                                            {this.state.verifyProduct.AntidoteStatement ? <div className="col-md-4 font-weight-bold">Antidote Statement</div> : null}
                                            {this.state.verifyProduct.AntidoteStatement ? <div className="col-md-8 mb-3">
                                                <a href={this.state.verifyProduct.AntidoteStatement} target="_blank">Download</a>
                                            </div> : null}




                                            {this.state.verifyProduct.Pamphlet ? <div className="col-md-4 font-weight-bold">Pamphlet</div> : null}
                                            {this.state.verifyProduct.Pamphlet ? <div className="col-md-8 mb-3">
                                                <img src={this.state.verifyProduct.Pamphlet} style={{ maxWidth: '250px' }} />
                                            </div> : null}

                                            {this.state.verifyProduct.Label ? <div className="col-md-4 font-weight-bold">Label</div> : null}
                                            {this.state.verifyProduct.Label ? <div className="col-md-8 mb-3">
                                                <img src={this.state.verifyProduct.Label} style={{ maxWidth: '250px' }} />
                                            </div> : null}

                                            <div className="col-md-12 border-bottom">  
                                            <div className="col-md-4 font-weight-bold">Web link/URL</div>
                                            <div className="col-md-8 mb-3">
                                            <a href={this.state.verifyProduct.ProductUrl}target="_blank">{this.state.verifyProduct.ProductUrl}</a>
                                            </div></div>


                                            {/* {this.state.verifyProduct.CustomerCareNo ? <div className="col-md-4 font-weight-bold">Customer Care Number</div> : null}
                                            {this.state.verifyProduct.CustomerCareNo ? <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.CustomerCareNo}
                                            </div> : null}

                                            {this.state.verifyProduct.CustomerCareEmail ? <div className="col-md-4 font-weight-bold">Customer Care Email</div> : null}
                                            {this.state.verifyProduct.CustomerCareEmail ? <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.CustomerCareEmail}
                                            </div> : null}

                                            {this.state.verifyProduct.CustomerCareAddress ? <div className="col-md-4 font-weight-bold">Contact Address</div> : null}
                                            {this.state.verifyProduct.CustomerCareAddress ? <div className="col-md-8 mb-3">
                                                {this.state.verifyProduct.CustomerCareAddress}
                                            </div> : null} */}


                                        </div>
                                    </div>
                                </div>
                            </div>
                       :""
                         
                    }

                 { (this.state.verifyProduct.ResponseCode) == "4" ?
                        this.state.isLoading ? <div className="block text-center pt-3"><img src={loadingPic} width="120" /></div> :
                                             
                        <div className="block1">
                            
                             <img src={FakeProductimg} style={{marginLeft: "42%" }} />
                             {/* <h3 className="text-center">{this.state.verifyProduct.ResponseMessage} !! </h3> */}
                            <div className="pt-3 err-mess text-center"> {this.state.verifyProduct.ResponseMessage}.</div>
                            
                            </div>:""
                    }

                     {(this.state.verifyProduct.ResponseCode) == "3" || (this.state.verifyProduct.ResponseCode) == "5" ?
                        this.state.isLoading ? <div className="block text-center pt-3"><img src={loadingPic} width="120" /></div> :
                                             
                        <div className="block1">
                        
                             <img src={FakeProductimg} style={{marginLeft: "42%", marginTop: "20px" }} />
                             {/* <h3 className="text-center">{this.state.verifyProduct.ResponseMessage} !! </h3> */}
                            <div className="pt-3 err-mess text-center"> {this.state.verifyProduct.ResponseMessage}.</div>

                            </div>:""
                            
                    }
<div className="col-md-12 text-center mt-4 mb-4">
<button className="btn btn-primary btn-lg" onClick={this.openDialog} >Feedback</button>
</div>
                    

                    {
                        (this.state.verifyProduct.ResponseCode) != null ?
                        <Dialog className="popup-modal" header={this.state.formHeading} visible={this.state.visible} modal={true} onHide={this.hideFunc}>
 <div className="block mb-5">
                                <h2 className="text-center mt-4 mb-5">Feedback Form</h2>
                                <form onSubmit={this.submitForm}>
                                    <div className="form-group">
                                        <label>Name<span style={{ color: 'red' }}>*</span>:</label>
                                        <input type="text" name="Name" value={this.state.Name} onChange={this.handleChange} className="form-control" />
                                        {this.state.formError.Name !== null ?
                                            <div className='error'>{this.state.formError.Name}</div> : null}
                                    </div>
                                    <div className="form-group">
                                        <label>Email Id:</label>
                                        <input type="email" name="email" value={this.state.email} onChange={this.handleChange} className="form-control" />
                                        {this.state.formError.email !== null ?
                                            <div className='error'>{this.state.formError.email}</div> : null}
                                    </div>
                                    <div className="form-group">
                                        <label>Mobile Number<span style={{ color: 'red' }}>*</span>:</label>
                                        <input type="text" maxLength={10} value={this.state.MobNo} name="MobNo" onChange={this.handleChange} className="form-control" />
                                        {this.state.formError.MobNo !== null ?
                                            <div className='error'>{this.state.formError.MobNo}</div> : null}
                                    </div>
                                    <div className="form-group">
                                        <label>Feedback<span style={{ color: 'red' }}>*</span>:</label>
                                        <textarea name="UsrFeedback" value={this.state.UsrFeedback} onChange={this.handleChange} className="form-control"></textarea>
                                        {this.state.formError.UsrFeedback !== null ?
                                            <div className='error'>{this.state.formError.UsrFeedback}</div> : null}
                                    </div>
                                    <div className="text-center"><button type="submit" className="btn btn-primary">Submit</button></div>
                                </form>


                            </div>
                        </Dialog>
                           
                            : ""
                    }


                </div>

            </div>
        )
    }
}